export enum TextGranularity {
    DOCUMENT = "DOCUMENT",
    PARAGRAPH = "PARAGRAPH",
    SENTENCE = "SENTENCE",
}

export enum ProductionType {
    LABELED_DATA = "LABELED_DATA",
}

export enum BateStampLocation {
    TOP_LEFT = "TOP_LEFT",
    TOP_CENTER = "TOP_CENTER",
    TOP_RIGHT = "TOP_RIGHT",
    BOTTOM_LEFT = "BOTTOM_LEFT",
    BOTTOM_CENTER = "BOTTOM_CENTER",
    BOTTOM_RIGHT = "BOTTOM_RIGHT",
}

export enum OrganizationFilter {
    RELEVANT = "RELEVANT",
    ALL = "ALL",
}
export enum UserTier {
    FREE = "FREE",
    PARTNER = "PARTNER",
    UNLIMITED = "UNLIMITED"
}

export enum ReferenceType {
    EMBEDDING = "EMBEDDING",
    EXPLANATION = "EXPLANATION",
    EXPLANATION_METADATA = "EXPLANATION_METADATA",
}

// ExchangeType lives in routines/schemas/transcript_analysis.tsx (source of truth)
export { ExchangeType } from "../routines/schemas/transcript_analysis";

// TAG and REQUEST_SET participate in the scoring pipeline (pre-created associations).
// NOTE: Type alone is not sufficient — use requiresAssociationConsistency() in
// schemas/tag.tsx for the full check (also excludes exchange type tags by name).
export enum TagType {
    TAG = "TAG",
    REQUEST_SET = "REQUEST_SET",
    ENTITY = "ENTITY",
    PRIVILEGE = "PRIVILEGE",
    FOLDER_UPLOAD = "FOLDER_UPLOAD",  // Upload folder (replaces legacy Folder model)
}


export enum JobType {
    UPLOAD = "UPLOAD",
    TAG_UPDATE = "TAG_UPDATE",
    PRODUCTION = "PRODUCTION",
    INVESTIGATION = "INVESTIGATION",
    SEED = "SEED",  // clone a template group into a new user's demo group
}

export enum JobStatus {
    UNASSIGNED = "UNASSIGNED",
    QUEUED = "QUEUED",
    PROCESSING = "PROCESSING",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
}


export enum DocumentType {
    EMAIL = "EMAIL",
    TRANSCRIPT = "TRANSCRIPT",
    DOCUMENT = "DOCUMENT",
    OTHER = "OTHER",
}

export enum DocumentOrigin {
    EMAIL = "EMAIL",
}

export enum FileType {
    PDF = "PDF",
    TXT = "TXT",
    HTML = "HTML",
    JSON = "JSON",
    JPEG = "JPEG",
    PNG = "PNG",
    DOCX = "DOCX",

    PST = "PST",
    MBOX = "MBOX",
    MSG = "MSG",
    EML = "EML",

    ZIP = "ZIP",
    TAR = "TAR",
    GZ = "GZ",

    DIRECTORY = "DIRECTORY",
    MACOS_METADATA = "MACOS_METADATA"


}

export enum GroupType {
    PUBLIC = "PUBLIC",
    IT = "IT",
    CASE = "CASE",
}
